import axios from "axios";

const API = axios.create({
  baseURL: "https://api.work-analysis.atgeotech.lava.com.az/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Xarici Auth API (login üçün ayrı baseURL)
const AUTH_API = axios.create({
  baseURL: "https://api.atgeotech.lava.com.az/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Login-dən alınan token-i bütün API sorğularına əlavə et
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("rotation-token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Schedule oxu
export const getSchedule = (contractId) =>
  API.get(`/schedule/${contractId}`);

// Yeni cədvəl yarat
export const generateSchedule = (contractId, startDate, endDate) =>
  API.post("/generate", {
    contract_id: contractId,
    start_date: startDate,
    end_date: endDate,
  });

// Manual adjustment
export const adjustSchedule = (contractId, date) =>
  API.post("/adjust", { contract_id: contractId, date });

// Plan vs Fact müqayisə
export const comparePlanFact = (contractId, date) =>
  API.post("/compare", { contract_id: contractId, date });

// Users siyahısı
export const getUsers = () => API.get("/users");

// Simulate Fact Əlavə Et
export const addTimesheet = (contractId, date, hours) =>
  API.post("/timesheet/add", { contract_id: contractId, date, hours });

// Team Schedule
export const getTeamSchedule = (start, end, search) =>
  API.get("/team-schedule", { params: { start, end, search, _t: Date.now() } });

// Login (xarici auth API-yə gedir)
// Server email+password-u base64 formatında "data" sahəsində gözləyir
export const loginUser = (email, password) => {
  const data = btoa(JSON.stringify({ email, password }));
  return AUTH_API.post("/auth/login", { data });
};
